export const ERROR_FORBIDDEN = 403;
export const ERROR_VALIDATION_FAILED = '0007';
export const ERROR_EPCS_INVITE_FAILED = '0008';
export const ERROR_EPCS_IDP_FAILED = '0009';
export const ERROR_INVALID_EPCS = '0010';
export const ERROR_LAC_LINK_BLOCKED = '0012';
export const ERROR_INVALID_DEA = '0014';
export const ERROR_INVALID_REFRESH_TOKEN_REQUEST = '0018';
